import axios, { type InternalAxiosRequestConfig, type AxiosInstance } from 'axios'

export const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const api: AxiosInstance = axios.create({ baseURL })

  api.interceptors.request.use(
    (config: InternalAxiosRequestConfig<any>) => {
      if (config.headers) {
        config.headers['Content-Type'] = 'application/json'
      }

      return config
    },
    (error: any) => error
  )

  return api
}
